
/* T5.36r (26 May 2026) — Reverted T5.36f position-fixed scroll-lock pattern.
   User feedback: introduced "huge empty space" when scrolling inside the
   mobile menu (position:fixed body + scrollable menu drawer = layout
   collisions on some viewports). Going back to the original (less-correct
   but visually safer) approach. The original "scroll-lost-on-close" issue
   was less bad than the new layout glitch. Kept the .mobile-nav null
   guard since that was preventing a separate TypeError on pages without
   a mobile-nav. */
const navToggles = document.querySelectorAll(".js-mobile-nav-toggle");

for (let i = navToggles.length - 1; i >= 0; i--) {
    const navToggle = navToggles[i];
    navToggle.addEventListener("click", () => {

        if (document.body.classList.contains("main-nav-active")) {
            document.body.classList.remove("main-nav-active");
            navToggle.classList.remove("mobile-menu-toggle-active");
            document.body.style.top = "0";
        } else {

            this.scrollPosition = window.pageYOffset;

            document.body.classList.add("main-nav-active");
            navToggle.classList.add("mobile-menu-toggle-active");
        }
    });
}

const mobileNav = document.querySelector(".mobile-nav");
/* T5.36f — Null-guard kept: prevents TypeError on pages without a mobile-nav. */
if (!mobileNav) {
    // No mobile-nav rendered — nothing more to do.
} else {

const navDropdownToggles = mobileNav.querySelectorAll(".convx__mobile-nav-toggle");
const navDropdownBackTogglesBack = mobileNav.querySelectorAll(".back-toggle");

for (let n = navDropdownToggles.length - 1; n >= 0; n--) {
    const dropdownToggle = navDropdownToggles[n];
    dropdownToggle.addEventListener("click", (e) => {
        e.preventDefault(); // ✅ Prevent default link behavior
        dropdownToggle.parentElement.classList.toggle("open");
    });
}
for (let n = navDropdownBackTogglesBack.length - 1; n >= 0; n--) {
    const dropdownBackToggle = navDropdownBackTogglesBack[n];
    dropdownBackToggle.addEventListener("click", () => {
        dropdownBackToggle.closest('li').classList.toggle("open");
    });
}
} /* end T5.36f mobileNav null-guard */